<div class="meta-navigation">
  <ng-content></ng-content>
</div>
